import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Grid, Heading, Tooltip, Button } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { HouseIcon } from '@enterprise-ui/icons';

// eslint-disable-next-line no-unused-vars
var Unauthorized = function Unauthorized(_ref) {
  var _ref$requiredAccess = _ref.requiredAccess,
    requiredAccess = _ref$requiredAccess === void 0 ? [] : _ref$requiredAccess;
  return /*#__PURE__*/React.createElement(Card, {
    className: "topPage-container"
  }, /*#__PURE__*/React.createElement(Grid.Container, {
    spacing: "expanded",
    justify: "center",
    align: "center",
    direction: "column",
    className: "fullHeight-container"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Heading, {
    size: 1
  }, "Access Restricted")), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Heading, {
    size: 3
  }, "At least one of the following entitlements required to access this feature")), /*#__PURE__*/React.createElement(Grid.Item, null, requiredAccess.map(function (adGroup) {
    return /*#__PURE__*/React.createElement(Heading, {
      size: 6,
      key: adGroup
    }, adGroup);
  })), /*#__PURE__*/React.createElement(Grid.Item, null), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Grid.Container, null, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Tooltip, {
    content: "Return Home",
    location: "top"
  }, /*#__PURE__*/React.createElement(Button, {
    iconOnly: true,
    size: "expanded",
    type: "primary",
    as: Link,
    to: "/",
    "aria-label": "Go to the homepage"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    size: "xl",
    icon: HouseIcon
  })))), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement("a", {
    href: "https://myaccess.target.com",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "expanded",
    type: "secondary"
  }, "Go to MyAccess")))))));
};

export { Unauthorized as default };
